// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"76":"3836ee01","534":"9ec6165e"}[chunkId] + ".css";
};